import { toast } from 'react-toastify';
import { ExamSessionDetails } from '../../../../../../../../api/types/programs/course/exams/response/exam-metadata';
import appApi from '../../../../../../../../api/app-api';

export const updateSessionDateOperation = async (
  currentProgramId: number | undefined,
  currentCourseId: number | undefined,
  examId: number,
  examSessionDetails: ExamSessionDetails,
  sessionDate: Date | undefined,
  setSessionDetails: (sessionDetails: ExamSessionDetails[]) => any,
) => {
  try {
    if (!currentProgramId || !currentCourseId) {
      toast.warn('לא ניתן לאתר את מזהה התוכנית ו/או הקורס');
      return;
    }

    if (!sessionDate) {
      toast.warn('תחילה יש לבחור תאריך בחינה');
    }

    if (examSessionDetails.classesSchedule.length > 0) {
      toast.warn(
        'למועד בחינה זה קיימים שיבוצים לכיתות תחילה יש להוריד את השיבוצים בטרם שינוי מועד זה',
      );
    }

    const res = await appApi.updateExamSessionDate(
      currentProgramId,
      currentCourseId,
      examId,
      examSessionDetails.id,
      sessionDate!,
    );

    setSessionDetails(res.data.body);
  } catch (e) {
    toast.error(`משהו קרה, יש לנסות שוב בעוד מספר רגעים...`);
  }
};
